import { AxiosInstance, AxiosResponse } from 'axios';

export default class HAAdminAPI {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  // ─── JE Type ─────────────────────────────────────────────────────────────────
  async listJeTypes(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/je-type/');
  }
  async createJeType(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/je-type/', data);
  }
  async updateJeType(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/je-type/${id}/`, data);
  }
  async deleteJeType(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/je-type/${id}/`);
  }

  // ─── JE Overall Type ─────────────────────────────────────────────────────────
  async listJeOverallTypes(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/je-overall-type/');
  }
  async createJeOverallType(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/je-overall-type/', data);
  }
  async updateJeOverallType(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/je-overall-type/${id}/`, data);
  }
  async deleteJeOverallType(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/je-overall-type/${id}/`);
  }

  // ─── Effectiveness Type ───────────────────────────────────────────────────────
  async listEffectivenessTypes(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/effectiveness-type/');
  }
  async createEffectivenessType(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/effectiveness-type/', data);
  }
  async updateEffectivenessType(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/effectiveness-type/${id}/`, data);
  }
  async deleteEffectivenessType(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/effectiveness-type/${id}/`);
  }

  // ─── JE Status ───────────────────────────────────────────────────────────────
  async listJeStatuses(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/je-status/');
  }
  async createJeStatus(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/je-status/', data);
  }
  async updateJeStatus(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/je-status/${id}/`, data);
  }
  async deleteJeStatus(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/je-status/${id}/`);
  }

  // ─── Standards Type ───────────────────────────────────────────────────────────
  async listStandardsTypes(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/standards-type/');
  }
  async createStandardsType(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/standards-type/', data);
  }
  async updateStandardsType(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/standards-type/${id}/`, data);
  }
  async deleteStandardsType(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/standards-type/${id}/`);
  }

  // ─── Designation Method ───────────────────────────────────────────────────────
  async listDesignationMethods(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/designation-method/');
  }
  async createDesignationMethod(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/designation-method/', data);
  }
  async updateDesignationMethod(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/designation-method/${id}/`, data);
  }
  async deleteDesignationMethod(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/designation-method/${id}/`);
  }

  // ─── Transaction Amort Type ───────────────────────────────────────────────────
  async listTransactionAmortTypes(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/transaction-amort-type/');
  }
  async createTransactionAmortType(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/transaction-amort-type/', data);
  }
  async updateTransactionAmortType(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/transaction-amort-type/${id}/`, data);
  }
  async deleteTransactionAmortType(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/transaction-amort-type/${id}/`);
  }

  // ─── JE Standard Template ─────────────────────────────────────────────────────
  async listJeStandardTemplates(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/je-standard-template/');
  }
  async createJeStandardTemplate(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/je-standard-template/', data);
  }
  async updateJeStandardTemplate(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/je-standard-template/${id}/`, data);
  }
  async deleteJeStandardTemplate(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/je-standard-template/${id}/`);
  }

  // ─── JE Standard ──────────────────────────────────────────────────────────────
  async listJeStandards(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/je-standard/');
  }
  async createJeStandard(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/je-standard/', data);
  }
  async updateJeStandard(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/je-standard/${id}/`, data);
  }
  async deleteJeStandard(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/je-standard/${id}/`);
  }

  // ─── Transaction Regression Values ───────────────────────────────────────────
  async listTransactionRegressionValues(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/transaction-regression-values/');
  }
  async createTransactionRegressionValue(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/transaction-regression-values/', data);
  }
  async updateTransactionRegressionValue(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/transaction-regression-values/${id}/`, data);
  }
  async deleteTransactionRegressionValue(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/transaction-regression-values/${id}/`);
  }

  // ─── Property Movement Type ───────────────────────────────────────────────────
  async listPropertyMovementTypes(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/property_movement_type/');
  }
  async createPropertyMovementType(data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.post('/v2/hedge-accounting/property_movement_type/', data);
  }
  async updatePropertyMovementType(id: number, data: Record<string, unknown>): Promise<AxiosResponse> {
    return this.client.put(`/v2/hedge-accounting/property_movement_type/${id}/`, data);
  }
  async deletePropertyMovementType(id: number): Promise<AxiosResponse> {
    return this.client.delete(`/v2/hedge-accounting/property_movement_type/${id}/`);
  }
}
